module.exports = __webpack_public_path__ + "assets/img/00134.f19db7ac.png";